/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The GoalstemplatesidGoalTemplateEscalation model module.
 * @module model/GoalstemplatesidGoalTemplateEscalation
 * @version v0.3
 */
export default class GoalstemplatesidGoalTemplateEscalation {
  /**
   * Constructs a new <code>GoalstemplatesidGoalTemplateEscalation</code>.
   * One care-team escalation relative to its anchor. Null clears it; omission preserves it.
   * @alias module:model/GoalstemplatesidGoalTemplateEscalation
   * @class
   * @param days {Number} Non-negative whole days. Stored as 0 when relation is on.
   * @param relation {module:model/GoalstemplatesidGoalTemplateEscalation.RelationEnum}
   */
  constructor(days, relation) {
    this.days = days;
    this.relation = relation;
  }

  /**
   * Constructs a <code>GoalstemplatesidGoalTemplateEscalation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalstemplatesidGoalTemplateEscalation} obj Optional instance to populate.
   * @return {module:model/GoalstemplatesidGoalTemplateEscalation} The populated <code>GoalstemplatesidGoalTemplateEscalation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GoalstemplatesidGoalTemplateEscalation();
      if (data.hasOwnProperty('days'))
        obj.days = ApiClient.convertToType(data['days'], 'Number');
      if (data.hasOwnProperty('relation'))
        obj.relation = ApiClient.convertToType(data['relation'], 'String');
      if (data.hasOwnProperty('anchor'))
        obj.anchor = ApiClient.convertToType(data['anchor'], 'String');
    }
    return obj;
  }
}

/**
 * Non-negative whole days. Stored as 0 when relation is on.
 * @member {Number} days
 */
GoalstemplatesidGoalTemplateEscalation.prototype.days = undefined;

/**
 * Allowed values for the <code>relation</code> property.
 * @enum {String}
 * @readonly
 */
GoalstemplatesidGoalTemplateEscalation.RelationEnum = {
  /**
   * value: "before"
   * @const
   */
  before: "before",

  /**
   * value: "after"
   * @const
   */
  after: "after",

  /**
   * value: "on"
   * @const
   */
  on: "on"
};
/**
 * @member {module:model/GoalstemplatesidGoalTemplateEscalation.RelationEnum} relation
 */
GoalstemplatesidGoalTemplateEscalation.prototype.relation = undefined;

/**
 * Allowed values for the <code>anchor</code> property.
 * @enum {String}
 * @readonly
 */
GoalstemplatesidGoalTemplateEscalation.AnchorEnum = {
  /**
   * value: "surgery"
   * @const
   */
  surgery: "surgery",

  /**
   * value: "referral"
   * @const
   */
  referral: "referral"
};
/**
 * Referral uses referral_date, falling back to the creation date in US Central time.
 * @member {module:model/GoalstemplatesidGoalTemplateEscalation.AnchorEnum} anchor
 * @default 'surgery'
 */
GoalstemplatesidGoalTemplateEscalation.prototype.anchor = 'surgery';
